import { app } from '../../../../bootstrap/core';
import { userSummarySectionComponent } from './userSummarySection.component';

app.component('userSummarySection', userSummarySectionComponent);
